module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-10-7ec6cb0cbbc34d888b6126de9d3f9311.png";